import React from 'react';
import {useNavigate, useParams} from 'react-router-dom';
import ServiceEditEmailComponent from "../../../../components/Admin/emails/services/ServiceEditEmailComponent";

const ServiceEditEmailPage = () => {
    const navigate = useNavigate();
    const params = useParams();

    let redirect = () => {
        navigate('/admin/email/danh-sach-email-dich-vu.html');
    }

    return <ServiceEditEmailComponent redirectFinish={ () => redirect() } emailId={ params.emailId } />;
}

export default ServiceEditEmailPage;